/* unplugin-vue-components disabled */import script from "./GraphicalReasoningItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GraphicalReasoningItem.vue?vue&type=script&setup=true&lang=js"

import "./GraphicalReasoningItem.vue?vue&type=style&index=0&id=9fa3c158&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fa3c158"]])

export default __exports__